import React from "react";
import { Loading } from "@tvg/design-system";
import { LoadingWrapper } from "./styled-components";

const PastPerformanceLoading = () => (
  <LoadingWrapper data-qa-label="mybets-pp-loading">
    <Loading size="xl" />
  </LoadingWrapper>
);

export default PastPerformanceLoading;
